/** @format */
/**
 * 缓存结构为key1: {key2:value}
 *
 * @format
 * @param {string} 缓存数据外层的key
 * @param {string} 缓存数据内层key
 */

export const getCache = (key1: string, key2: string) => {
	const cache = window.sessionStorage.getItem(key1) || '{}';

	if (cache) {
		return JSON.parse(cache)[key2];
	}
	return null;
};
/**
 * 缓存结构为key1: {key2:value}
 * @param  {string} 缓存数据外层的key
 * @param  {string} 缓存数据内层key
 * @param  {any} 缓存数据值
 */
export const setCache = (key1: string, key2: string, value: any) => {
	const cache = window.sessionStorage.getItem(key1) || '{}';

	const cacheObj = JSON.parse(cache);
	cacheObj[key2] = value;

	window.sessionStorage.setItem(key1, JSON.stringify(cacheObj));
};

/**
 * 根据keys选择对象中的属性
 * @value 对象
 * @keys 选择的key，以`.`分隔
 * @returns 选择的对象
 */
export const chains = (value: Record<string, any>, keys: string | string[], splitStr = '.') =>
	(Array.isArray(keys) ? keys : keys.split(splitStr)).reduce((val, item) => {
		return val ? val[item] : val;
	}, value);
